import { render } from "./PaymentsDetails.vue?vue&type=template&id=bd64365c&scoped=true"
import script from "./PaymentsDetails.vue?vue&type=script&lang=js"
export * from "./PaymentsDetails.vue?vue&type=script&lang=js"

import "./PaymentsDetails.vue?vue&type=style&index=0&id=bd64365c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd64365c"]])

export default __exports__